const getIsError = (type, errors) => errors
  .filter((error) => error.propertyPath === type).length !== 0;

export default getIsError;
